import { render, staticRenderFns } from "./SummerNote.vue?vue&type=template&id=768a80fe&scoped=true&"
import script from "./SummerNote.vue?vue&type=script&lang=js&"
export * from "./SummerNote.vue?vue&type=script&lang=js&"
import style0 from "./SummerNote.vue?vue&type=style&index=0&id=768a80fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768a80fe",
  null
  
)

export default component.exports